import * as React from 'react'
import LeftSideMenu from './LeftSideMenu'
import TicketsTable from './TicketsTable'
import MobileTicketsTable from './components/MobileTicketsTable'
import MobileMenu from './components/MobileMenu'
import AnimatedBurgerIcon from './components/AnimatedBurgerIcon'
import useMobile from './hooks/useMobile'

const Tickets = (props) => {
    const { isMobile } = useMobile()
    const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false)

    return (
        <div style={{
            display: 'flex',
            height: '100vh',
        }}>
            {!isMobile && <LeftSideMenu active={props.active} user={props.user} apiClient={props.apiClient}/>}

            <div className="shop-page" style={{ 
                width: isMobile ? '100%' : 'calc(100% - 280px)',
                height: '100vh',
                padding: isMobile ? '0' : '8px',
                marginLeft: isMobile ? '0' : '280px',
                overflow: isMobile ? 'hidden' : 'auto'
            }}>
                {isMobile && (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: 'var(--spacing-md)',
                        background: 'var(--dark-gray)',
                        borderBottom: '1px solid var(--light-gray)',
                        position: 'sticky',
                        top: 0,
                        zIndex: 100
                    }}>
                        <AnimatedBurgerIcon
                            isOpen={mobileMenuOpen}
                            onClick={() => setMobileMenuOpen(true)}
                        />
                        <h1 className="shop-page-title" style={{ 
                            margin: 0,
                            fontSize: 'var(--text-lg)',
                        }}>
                            Tickets
                        </h1>
                        <div style={{ width: '32px' }} />
                    </div>
                )}

                {isMobile && (
                    <MobileMenu 
                        user={props.user} 
                        active={props.active} 
                        apiClient={props.apiClient}
                        isOpen={mobileMenuOpen}
                        onClose={() => setMobileMenuOpen(false)}
                    />
                )}

                <div style={{
                    height: isMobile ? 'calc(100vh - 60px)' : 'auto',
                    overflow: isMobile ? 'auto' : 'visible',
                    padding: isMobile ? 'var(--spacing-sm)' : '0',
                    width: '100%'
                }}>
                    {isMobile ? (
                        <MobileTicketsTable apiClient={props.apiClient}/>
                    ) : (
                        <TicketsTable apiClient={props.apiClient}/>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Tickets
